<a class="c-pointer" [routerLink]="adminRoot">
  <span class="logo-single mb-0" [ngStyle]="{width: logoWidth, height: logoHeight}"></span>
</a>
